import { Component, OnInit } from '@angular/core';
import { BankService } from '../service/bank.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.css']
})
export class BankComponent implements OnInit {
  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];

  constructor(private dataService: BankService, private router: Router) { }
  ngOnInit() {
    this.getAllList();
    this.cols = [
      { field: 'BankNumber', header: 'מספר בנק' },
      { field: 'BankName', header: 'שם בנק' },
    ];
  }

  getAllList(): any {
    this.dataService.getList().subscribe((result: any) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  redirectToUpdate(bankNumber: number, BankName: string): void {
    if (bankNumber > 0 && (bankNumber != null && bankNumber != undefined)) {
      this.router.navigate(['/bank-update', bankNumber, BankName]);
    }
    else {
      this.showMessage('error', '', 'תקלה בעדכון');
    }
  }

  delete(bankNumber: number, BankName: string): void {
    if (bankNumber > 0 && (bankNumber != null && bankNumber != undefined)) {
      let ok = confirm(`האם ברצונך למחוק את ${BankName} ?`);
      if (ok) {
        this.dataService.delete(bankNumber).subscribe((result: any) => {
          if (result == "Success") {
            this.showMessage('success', '', 'המחיקה בוצעה בהצלחה');
            this.getAllList();
          }
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה במחיקה');
        });
      }
    }
    else {
      this.showMessage('error', '', 'תקלה במחיקה');
    }
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/bank/bank.component.ts